// Imports: Dependencies
import {all, fork} from 'redux-saga/effects';
// Imports: Redux Sagas
import authSaga from './auth.saga';
import otherSaga from './others.saga';
import domainSaga from './domains.saga';
import pollSaga from './polling.saga';
import employeeManagementSaga from "./employee-management.saga";
import metaSaga from "./meta.saga";
import {hcpBasicDetailsSaga} from "./hcp-management.saga";

// Redux Saga: Root Saga
export function* rootSaga() {
    yield all([
        fork(authSaga),
        fork(otherSaga),
        fork(domainSaga),
        fork(pollSaga),
        fork(employeeManagementSaga),
        fork(metaSaga),
        fork(hcpBasicDetailsSaga)

    ]);
}
